import { Component, OnInit, HostListener, DOCUMENT } from '@angular/core';
import { AuthService } from 'src/app/services/auth/auth.service';
import ConfettiGenerator from 'confetti-js';
import { PageScrollService } from 'ngx-page-scroll-core';
import { FormBuilder, Validators } from '@angular/forms';
import { MarketingLeadService, MarketingLeadData } from 'src/app/services/marketing-lead/marketing-lead.service';
import { IndustriesService } from 'src/app/services/industries/industries.service';
import { faCircleNotch, faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { I18nHelperService } from '@xref/ngx';
import { Inject } from '@angular/core';


@Component({
  selector: 'xqnr-sent-to-email',
  templateUrl: './sent-to-email.component.pug',
  styleUrls: ['./sent-to-email.component.scss'],
  standalone: false
})
export class SentToEmailComponent implements OnInit {
  loaded = false;
  showGenericError = false;
  isXrefUser = false;

  showLeadForm = true;
  leadFormSubmitting = false;
  leadFormSubmitted = false;

  industriesList = [];

  userAlreadySubmitted = false;

  fa = {
    circleNotch: faCircleNotch,
    chevronDown: faChevronDown
  };

  confettiSettings = {
    target: 'confetti',
    colors: [
      [148, 213, 0],
      [244, 202, 36],
      [182, 228, 19],
      [212, 115, 230],
      [95, 157, 234]
    ],
    props: ['square', 'line'],
    rotate: true
  };

  blogPostConfig = [
    {
      title: 'thankYou.blog.postOne.title',
      link: 'https://xref.com/en/blog/the-five-phases-of-successful-reference-checking/139/?utm_source=template-builder&utm_medium=referral&utm_campaign=great-questions&utm_content=blog',
      image: '/images/ty-five-phases.jpg'
    },
    {
      title: 'thankYou.blog.postTwo.title',
      link: 'https://xref.com/en/blog/online-reference-checking-the-xref-way-explained/278/?utm_source=template-builder&utm_medium=referral&utm_campaign=great-questions&utm_content=blog',
      image: '/images/ty-online-ref-explained.jpg'
    },
    {
      title: 'thankYou.blog.postThree.title',
      link: 'https://xref.com/en/blog/smart-hr-combining-tech-and-personal-touch/297/?utm_source=template-builder&utm_medium=referral&utm_campaign=great-questions&utm_content=blog',
      image: '/images/ty-smart-tech.jpg'
    }
  ];

  leadForm = this.fb.group({
    company: ['', [Validators.required]],
    industry: ['', [Validators.required]],
    phone: ['', [Validators.required]],
    hires: ['', [Validators.required, Validators.pattern('[0-9]+')]]
  });

  constructor(
    private auth: AuthService,
    private fb: FormBuilder,
    private marketingLead: MarketingLeadService,
    private industries: IndustriesService,
    private animateScrollService: PageScrollService,
    public i18nHelper: I18nHelperService,
    @Inject(DOCUMENT) private document: any,
  ) {}

  @HostListener('window:resize', ['$event'])
  onResize(event: any): any {
    new ConfettiGenerator(this.confettiSettings).render();
  }



  ngOnInit() {
    this.isXrefUser = this.auth.isXrefUser();

    if (this.isXrefUser) {
      this.setShowLeadForm();
      this.setLoaded();

    } else {
      this.getIndustries();
      this.prePopData();
    }

    new ConfettiGenerator(this.confettiSettings).render();
  }

  setLoaded() {
    this.loaded = (
      this.isXrefUser ||
      (
        this.industriesList.length > 0 &&
        this.leadForm.controls.industry.value as any > 0
      )
    );
  }

  scrollPastHeader() {
    this.animateScrollService.scroll({
      document: this.document,
      scrollTarget: '#headerEnd',
      duration: 500,
    });
  }

  setShowLeadForm() {
    this.showLeadForm = !this.userAlreadySubmitted && !this.isXrefUser;
  }

  prePopDataSuccess = (res: any) => {
    this.leadForm.controls.industry.setValue(res.industry);
    this.userAlreadySubmitted = res.submitted;

    this.setLoaded();

    this.setShowLeadForm();
  };

  prePopDataError = (res: any) => {
    console.error(res);
  };

  prePopData() {
    this.marketingLead.getPrePop().subscribe(
      this.prePopDataSuccess,
      this.prePopDataError
    );
  }

  getIndustriesSuccess = (res: any) => {
    this.industriesList = res;

    this.setLoaded();
  };

  getIndustriesError = (res: any) => {
    console.error(res);
  };

  getIndustries() {
    this.industries.getIndustries().subscribe(
      this.getIndustriesSuccess,
      this.getIndustriesError
    );
  }

  isEnglish() {
    return this.i18nHelper.locale.split('-')[0] === 'en';
  }

  submitLeadFormSuccess = () => {
    this.leadFormSubmitting = false;
    this.leadFormSubmitted = true;
  };

  submitLeadFormError = (res: any) => {
    console.error(res);
    this.showGenericError = true;
  };

  submitLeadForm() {
    if (this.leadForm.valid) {
      this.leadFormSubmitting = true;

      const postData: MarketingLeadData = {
        phone: this.leadForm.controls.phone.value,
        organisation: this.leadForm.controls.company.value,
        annual_hires: this.leadForm.controls.hires.value as any,
        industry: parseInt(this.leadForm.controls.industry.value, 10)
      };

      this.marketingLead.saveLead(postData)
        .subscribe(this.submitLeadFormSuccess, this.submitLeadFormError);
    }
  }
}
